<ng-container *ngIf="!!page">
    <tt-card>
        <form (submit)="$event.preventDefault(); readGantt()">
            <tt-input ttLabel="searchtext" [(ttModel)]="page.searchtext" (ttModelChange)="!$event && readGantt()" ttShowClearButton>
                <tt-form-field-button buttons ttIcon="fas fa-search" (ttClick)="readGantt()"></tt-form-field-button>
            </tt-input>
        </form>
    </tt-card>
    <tt-gantt *ngIf="!!gantt" [(ttOptions)]="gantt"></tt-gantt>
    <tt-card *ngIf="page.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</ng-container>
